export const DEFAULT_BALANCE = {
  availableFreeVideos: 0,
  availableMinutes: 0,
  canBuyMinutes: false,
  hasActiveEnterprisePlan: false,
  hasActiveSubscription: false,
  hasArchivedSubscription: false,
  hasBusinessPlan: false,
  hasCanceledSubscription: false,
  hasEnterprisePlan: false,
  hasExpiredSubscription: false,
  hasFreeLipSyncMinutes: false,
  hasFreeSubscription: false,
  hasFreeVideos: false,
  hasMinutes: false,
  hasPastDueSubscription: false,
  hasPausedSubscription: false,
  hasSubscriptionCancelAtPeriodEnd: false,
  hasSubscriptionWithArchivedPrice: false,
  hasTrialingEnterprisePlan: false,
  hasTrialPlan: true,
  hasUnpaidSubscription: false,
  purchasedBoosters: null,
};
